
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The three-letter ISO 4217 currency code of the product price, in uppercase.`}</p>
    <p>{`This field is intended for budgeting and not to be directly shown to hirer.`}</p>
    <p>{`Please contact SEEK before you use this field.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;